import * as React from 'react';
import { Table } from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';

interface IStatisticsListProps {
    list: any;
    hasDoneSearch: boolean;
}

const format = (input: any) => {
    if (typeof input == 'number' && input >= 10000) {
        var parts = input.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        return parts.join('.');
    }

    return input;
};

const StatisticsList = (props: IStatisticsListProps) => {
    return (
        <div>
            {props.hasDoneSearch && !props.list && (
                <div>{Translate('statistics/page/list/no-results')}</div>
            )}
            {props.list && (
                <Table className="table" hover responsive>
                    <thead>
                        <tr>
                            <th></th>
                            {props.list.headers.map((x, i) => (
                                <th key={'header-' + i}>{x}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {props.list.rows.map((x, ix) => (
                            <tr key={'row-' + ix}>
                                <td>{x.name}</td>
                                {x.columns.map((c, ic) => (
                                    <td key={'column-' + ic}>{format(c)}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </div>
    );
};

export default StatisticsList;
